module.exports = __webpack_public_path__ + "img/mazatlan_home_banner_5.a27277a6.jpeg";